import { Button, Form, Modal, Select } from 'antd';
import { default as React } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { layoutCategoryFieldModalSliceDispatch, pickAFileSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";

function LayoutCategoryFieldModal({ caption, layout }) {
    const currentQuestions = useSelector((state: any) => state.pickAFile.questions);
    const currentLayout = useSelector((state: any) => state.pickAFile.layout);

    const open = useSelector((state: any) => state.layoutCategoryFieldModal.open);
    const layoutToAdd = useSelector((state: any) => state.layoutCategoryFieldModal.layoutToAdd) ?? layout;

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    let questionDropDownList = currentQuestions.map(b => { return ({ key: b.dataKey, text: b.dataKey, value: b.dataKey }) })

    let adder = AddLayoutField;
    let buttonCaption = caption;

    function AddLayoutField(oldList, newLayout) {
        //Find the matching row
        let matchIndex = currentLayout.findIndex(l => l.tab == newLayout.tab && l.name == newLayout.name)

        if (matchIndex > -1) {
            let match = currentLayout[matchIndex]

            match.fields = newLayout.fields

            let listToUse = currentLayout

            listToUse.splice(matchIndex, 1, match)

            dispatch({ type: pickAFileSliceDispatch.setLayout, payload: listToUse })

            CreateContentsFromStates({ layout: listToUse });
        }
    }

    const onQuestionsDropDownChange = (value) => {
        dispatch({ type: layoutCategoryFieldModalSliceDispatch.setLayoutToAdd, payload: { ...layoutToAdd, ["fields"]: value } });
    }

    const onSubmit = () => {
        if (adder) {
            adder(null, layoutToAdd)
        }

        dispatch({ type: layoutCategoryFieldModalSliceDispatch.setOpen, payload: false });
    }

    const onCancel = () => {
        dispatch({ type: layoutCategoryFieldModalSliceDispatch.setOpen, payload: false });
    }

    return open ? (
        <Modal
            title="Layout Details"
            footer={null}
            closable={false}
            open={open}
            destroyOnHidden={true}
        >
            <Form
                onFinish={onSubmit}
                onFinishFailed={onCancel}
                preserve={false}
            >
                <Form.Item name="Questions" label="Questions">
                    <Select
                        placeholder='Select Question(s)'
                        mode="multiple"
                        options={questionDropDownList}
                        defaultValue={layoutToAdd.fields}
                        onChange={onQuestionsDropDownChange}
                    />
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button onClick={onCancel}>
                            Cancel
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    ) : (
        <Button onClick={() => {
            dispatch({ type: layoutCategoryFieldModalSliceDispatch.setOpen, payload: true });
            dispatch({ type: layoutCategoryFieldModalSliceDispatch.setLayoutToAdd, payload: layout });
        }}>{buttonCaption}</Button>
    )
}

export default LayoutCategoryFieldModal;